<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates8">
<p class="centerImage"><img alt="images" id="plate8" src="images/plate8.jpg"/></p>
<p class="caption">We entertain some ladies at Drem in August 1940. From the left: Archie McKeller DFC, Bunny Currant, Cyril Passy and RWF. <em class="italic">(Croydon Airport Assn)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates8.vue?06300364